// Request-a-new-invite service
// ------------------------------
// Lets a stranded invitee (temporary password expired) trigger a fresh invite
// from the LOGGED-OUT /welcome page. It calls the @aws_iam requestNewInvite
// mutation as a Cognito identity-pool GUEST (authMode "AWS_IAM"); the backend
// always returns the same neutral result and only ever resends to a
// FORCE_CHANGE_PASSWORD account's OWN email (see
// handlers/userdatasource.request_new_invite).
//
// The mutation string lives here rather than in services/graphql/mutations.ts
// because that file is codegen output ("auto generated ... will be overwritten");
// keeping it local prevents clobbering and co-locates the feature's data access.

import { API, graphqlOperation as _graphqlOperation } from "aws-amplify";

const requestNewInviteMutation = `mutation RequestNewInvite($input: RequestNewInviteInput!) {
  requestNewInvite(input: $input) {
    ok
  }
}
`;

// Force AWS_IAM auth so this resolves via the identity-pool GUEST role rather
// than a (non-existent) Cognito session. This is the ONLY call in the app that
// does not use the Cognito-user-pools default auth mode.
const graphqlOperation = (query: any, variables?: any) => ({
  ..._graphqlOperation(query, variables),
  authMode: "AWS_IAM" as const,
});

// Never throws and returns nothing meaningful: the server does not reveal
// whether the account exists, so there is nothing to branch on. Transport errors
// are swallowed too, so the UI shows the SAME neutral confirmation in every case
// (no user enumeration). Failures are logged for operators only.
export async function requestNewInvite(email: string): Promise<void> {
  try {
    await API.graphql(graphqlOperation(requestNewInviteMutation, { input: { email } }));
  } catch (requestError: any) {
    const detail = requestError?.errors?.[0]?.message || requestError?.message;
    console.error(`requestNewInvite failed: ${detail}`);
  }
}
